export default {
  // 指令的定义
  mounted(el, binding, vNode) {
    let flag // 鼠标按下
    let downX // 鼠标点击的x下标
    let scrollLeft // 当前元素滚动条的偏移量
    el.style.cursor = 'grab'
    el.addEventListener('mousedown', (e) => {
      flag = true
      downX = e.clientX // 获取到点击的x下标
      scrollLeft = el.scrollLeft // 获取当前元素滚动条的偏移量
      console.log('mousedown')
    })

    el.addEventListener('mousemove', (e) => {
      if (flag) {
        el.style.cursor = 'grabbing'
        // 判断是否是鼠标按下滚动元素区域
        // 获取移动的x轴
        let moveX = e.clientX
        // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
        let scrollX = moveX - downX
        // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
        el.scrollLeft = scrollLeft - scrollX
      }
    })

    // 鼠标抬起停止拖动
    el.addEventListener('mouseup', function (event) {
      flag = false
      console.log('mouseup')
    })
    // 鼠标离开元素停止拖动
    el.addEventListener('mouseleave', function (event) {
      flag = false
    })
  },
}
